<!--  * @Author: qinkexin coco_qkx@163.com  * @Date: 2025-01-06 13:37:23  * @LastEditors: qinkexin coco_qkx@163.com  * @LastEditTime: 2026-04-15 09:39:31  * @FilePath: \doab-front\src\components\AuditDetail\AuditDetail.vue  * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE --> <template>   
<div class="audit-detail" v-if="shouldShowAuditDetail">     <i class="el-icon-warning"></i>     <span v-if="isManualAuditRejected" v-html="errorText"></span>     <span v-else-if="isRobotAuditRejected" class="audit-detail-system">       {{ errorText1 }}       <!-- <span class="feekback" @click="openOnline">人工反馈</span> -->     </span>     <Online ref="online"/>   
</div> </template>

<script>
import Online from '@/views/my/help/components/online.vue'
export default {
  name: "AuditDetail",
  props: {
    detail: {
      type: Object,
      default: function() { return {}},
    },
    type: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
    }
  },
  components: { Online },
  computed: {
    shouldShowAuditDetail() {
      return this.isManualAuditRejected || this.isRobotAuditRejected
    },
    isManualAuditRejected() {
      if(this.type !== 'doc') {
        const { auditState, auditStatus } = this.detail
        return auditState === 2 || auditStatus === 2
      } else {
        return this.detail.auditState == 2 && this.detail.auditType == 2
      }
    },
    isRobotAuditRejected() {
      if(this.type !== 'doc') {
        const { auditState, auditStatus, robotAuditStatus } = this.detail
        const isPending = auditState === 0 || auditStatus === 0
        return isPending && robotAuditStatus === 2
      } else {
        /* @ApiModelProperty("审核状态 待审核：0 通过：1 不通过：2")
          private Integer auditState;
          */
        return this.detail.auditState == 2 && this.detail.auditType == 1
      }
    },
    errorText() {
      return `内容人工审核不通过，建议修改后重新发布（${this.detail.auditRemark}）`
    },
    errorText1() {
      return `内容机器审核不通过，建议修改后重新发布或等待人工审核`
    }
  },
  mounted() {
  },
  methods: {
    openOnline() {
      this.$refs.online.open()
    },
  },
  watch: {
  }
}
</script>

<style lang='scss' scoped>
  .audit-detail {
    margin-bottom: 16px;
    padding: 8px 15px;
    border: 1px solid #F8ABAB;
    color: #F34D4D;
    line-height: 22px;
    font-size: 12px;
    background: #FEF0F0;
    border-radius: 4px 4px 4px 4px;
    .el-icon-warning {
      margin-right: 7px;
      font-size: 14px;
    }
    .audit-detail-system {
      clear: both;
      .feekback {
        float: right;
        color: #5584FB;
        cursor: pointer;
      }
    }
  }
</style>
